import React from 'react';
import clsx from 'clsx';
import { emailAddressOf } from '@repo/lib';
import Tooltip from './Tooltip';
import Dash from './Dash';

const statusOf = (recipientEvents, recipient) => {
  const events = (recipientEvents ?? [])
    .filter(({ email }) => emailAddressOf(email) === emailAddressOf(recipient))
    .map(({ event }) => event);
  if (events.includes('Bounced')) return 'Bounced';
  if (events.includes('Delivered')) return 'Delivered';
  return null;
};

/**
 * The first address carries the row's status. The rest sit behind a +N chip,
 * which turns red when one of them bounced and lists the bounced ones first.
 */
export default function EmailRecipients({ recipients, recipientEvents, layout = 'default' }) {
  const parsedRecipients =
    recipients.length === 1
      ? recipients[0].split(',').map(recipient => recipient.trim())
      : recipients;

  const isTableLayout = layout === 'table';

  if (parsedRecipients.length > 1) {
    const others = parsedRecipients
      .slice(1)
      .map(recipient => ({ recipient, status: statusOf(recipientEvents, recipient) }));
    const bounced = others.filter(({ status }) => status === 'Bounced');
    const listed = [...bounced, ...others.filter(({ status }) => status !== 'Bounced')];

    return (
      <div
        className={`inline-flex items-center justify-start gap-2 ${isTableLayout ? 'w-full' : ''}`}
      >
        <span className="truncate" title={parsedRecipients[0]}>
          {parsedRecipients[0]}
        </span>

        <div tabIndex={0} className="flex-shrink-0">
          <Tooltip
            label={listed.map(({ recipient, status }) => (
              <div key={recipient}>{status ? `${recipient} (${status})` : recipient}</div>
            ))}
          >
            <span
              className={clsx(
                'rounded-md px-1 py-0.5 text-xs',
                bounced.length > 0
                  ? 'bg-destructive/10 text-destructive'
                  : 'bg-gray-200 dark:bg-accent',
              )}
            >
              +{parsedRecipients.length - 1}
            </span>
          </Tooltip>
        </div>
      </div>
    );
  }

  return (
    <span className="truncate" title={parsedRecipients[0]}>
      {parsedRecipients[0] || <Dash />}
    </span>
  );
}
